module.exports = __webpack_public_path__ + "static/media/logo.e25121b6.png";